import { CmsApplianceDetailsModelSerialForm } from './cms-appliance-details-model-serial-form.interface';

export interface ApplianceDetailsModelSerialFormConfig {
  cmsData: CmsApplianceDetailsModelSerialForm;
  modelNumberRequired: boolean;
  serialNumberRequired: boolean;
}
